// extracted by mini-css-extract-plugin
export default {"spinner":"BlockingLoader_spinner__38Rcd"};